import axios from '@/axios';
import { faTirePressureWarning } from '@fortawesome/pro-duotone-svg-icons';

export default {
  data() {
    return {
      showPdfReader: false,
      pdfReaderSrc: null,
      usePdfPreview: false,
      customOfflineRatersEndpoint: null,
    }
  },
  methods: {
    async openUrl(url) {
      try {
        window.open(
          url.DocumentDownloadUrl,
          "_blank");
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
  },
};
